/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/prefer-stateless-function */
/* eslint-disable quotes */
/* eslint-disable indent */
import React from 'react';
import { InputNumber, Button, Row, Col, Modal, Table, Form, Input, Space } from 'antd';
import { PlusOutlined, EditOutlined, MinusCircleOutlined } from '@ant-design/icons';
import _ from 'lodash';
import utilities from '../common/utils';
import Loadingsvg from "./common/Loadingsvg";
import DisplayControl from './DisplayControl';
import consts, { TIME_OF_DEBOUNCE } from "../consts"
const PERMISSION_LINK_SCREEN_ADD_AFFILIATE = "/affiliate-admin"

const dataColumns = [
  {
    title: '',
    dataIndex: 'level',
    render: (record) => record ? 'Phần trăm hoa hồng từ người thứ ' + record : 'Phần trăm hoa hồng từ người thứ ',
  },
  {
    title: 'Phần trăm',
    dataIndex: 'rate',
    width: '25%',
  },
];

const coinColumns = [
  {
    title: 'Loại đồng',
    dataIndex: 'coin',
  },
  {
    title: 'Giá trị tối thiểu',
    dataIndex: 'value',
  },
  {
    title: 'Hành động',
    render: () => <EditOutlined style={{ fontSize: '20px' }} />
  },
];
class AffilateSetting extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      isLoadingSubmit: false,
      data: []
    };

    this.form = React.createRef();
  }

  componentDidMount() {
    this.props.getAffiliateSetting();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ data: [...nextProps.setting] });
  }

  add = () => {
    var temp = this.state.data;
    temp.push({
      level: temp.length + 1,
      rate: 0
    });
    this.setState({ data: temp }, () => { this.form.current.resetFields() });
  }

  onSubmit = (values) => {
    this.setState({
      isLoadingSubmit: true
    })
    this.filter();
  };

  onChange = (index, value) => {
    var temp = [...this.state.data];
    temp[index] = {
      level: index + 1,
      rate: value
    };
    this.setState({ data: temp });
  };

  filter = _.debounce(() => {
    var temp = [...this.state.data];
    while (temp[temp.length - 1].rate === 0) {
      temp.pop();
    }
    if (temp.reduce((sum, item) => {
      return sum + item.rate;
    }, 0) < 0.9) {
      if (this.isSorted()) {

        let request = {
          affiliate_setting: this.state.data,
          pubkey: this.props.pubkey
        };
        this.setState({
          data: temp,
        });
        this.props.postAffiliateSetting(request, () => {
          this.setState({
            isLoadingSubmit: false,
            visible: false
          })
        })
      } else {
        utilities.showNotification('Lỗi', 'Thiết lập không hợp lệ', 'error');
        this.setState({
          isLoadingSubmit: false,
        })
      }
    } else {
      utilities.showNotification('Lỗi', 'Thiết lập không hợp lệ', 'error');
      this.setState({
        isLoadingSubmit: false,
      })
    }
  }, TIME_OF_DEBOUNCE)
  isSorted() {
    for (var i = 0; i < this.state.data.length - 1; i++) {
      if (this.state.data[i] < this.state.data[i + 1]) {
        return false;
      }
    }
    return true;
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = e => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = e => {
    this.setState({
      visible: false,
      data: [...this.props.setting]
    });

  };

  render() {
    return (
      <div className="withdrawalHistory">
        <div>
          <h2>Chương trình giới thiệu</h2>
        </div>

        <Row gutter={20}>
          <Col span={12}>
            <div>
              <div className="feature-add">
                <h4> Phần trăm hoa hồng người dùng được nhận </h4>
                <DisplayControl permission_link_screen={PERMISSION_LINK_SCREEN_ADD_AFFILIATE} action="POST">
                  <Button onClick={this.showModal}>Chỉnh sửa</Button>
                </DisplayControl>
              </div>
              <Table columns={dataColumns} dataSource={this.props.setting} bordered
                pagination={false} />
            </div>
          </Col>
        </Row>

        <Modal
          title="Chương trình giới thiệu"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={false}
        >
          <Form name="dynamic_form_nest_item" autoComplete="off" onFinish={this.onSubmit}
            initialValues={_.chain(this.state.data)
              .keyBy('level')
              .mapValues('rate', function (rate) {
                return rate.rate;
              })
              .value()}
            ref={this.form}
          >
            {
              this.state.data.map((item, index) => {
                return (
                  <Form.Item key={index} name={item.level}
                    label={item.level ? 'Phần trăm hoa hồng từ người thứ ' + item.level : 'Phần trăm hoa hồng từ người thứ 1'}>
                    <InputNumber
                      min={0} max={1}
                      onChange={(value) => this.onChange(index, value)}
                    />
                  </Form.Item>
                );
              })}
            <Form.Item>
              <Button type="dashed" onClick={this.add} block icon={<PlusOutlined />}>
                Thêm tầng
              </Button>
            </Form.Item>

            <Form.Item>
              <DisplayControl permission_link_screen={consts.AUTH.AFFILIATE_ADMIN} action={consts.CONTROLS.POST}>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: '84px', margin: '0px 44%' }}
                  icon={(
                    <Loadingsvg
                      name="bars"
                      hidden={!this.state.isLoadingSubmit}
                      size={25}
                    />
                  )}
                >
                  {this.state.isLoadingSubmit === false ? 'Xác nhận' : ''}
                </Button>
              </DisplayControl>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default AffilateSetting;
